import autoTable from "jspdf-autotable";
import { PDF_TABLE_STYLE,PDFCOLORSHEME } from "../../../../../../component/constent";

function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function drawGrandTotal(doc, totals) {
  const startY = 10

  autoTable(doc, {
    startY,
    ...PDF_TABLE_STYLE,
    theme: "grid",

   head: [[
      
      "Prime Labour",
      "Prime Store",
      "",
      "On Cost Labour",
      "On Cost Store",
      "SUP Store",
      "Freight",
      "Store",
      "Profit"
    ]],

    body: [[
      "GRAND TOTAL",
       format(totals.primeLabour),
       format(totals.primeStores),
       format(totals.onCostLabour),
       format(totals.onCostStores),
       "0.00",
       "0.00",
       "0.00",
       "0.00"
    ]],

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      cellPadding: 2,
      halign: "right",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_GRAND_TOTAL,
      textColor: PDFCOLORSHEME.FONT_COLOR_GRAND_TOTAL,
      fontStyle: "bold",
      halign: "center",
    },

    columnStyles: {
      0: {
        halign: "left",
        fontStyle: "bold",
        cellWidth: 40,
      },
    },

    // didParseCell(data) {
    //   if (data.section === "body") {
    //     data.cell.styles.fontStyle = "bold";
    //     data.cell.styles.fillColor = [230, 240, 255];
    //   }
    // },
  });
}